import { createFileRoute } from "@tanstack/react-router";
import PatientInfoHub from "@/pages/PatientInfoHub";
export const Route = createFileRoute("/contents/patient-info/")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Patient Information Hub | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Essential patient information, cost and insurance coverage, video resources, and FAQs for advanced psychiatric treatments at Neuro Wellness TMS Centers of.",
        },
        {
          property: "og:title",
          content:
            "Patient Information Hub | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Essential patient information, cost and insurance coverage, video resources, and FAQs for advanced psychiatric treatments at Neuro Wellness TMS Centers of.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/contents/patient-info",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/patient-info",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PatientInfoHub />;
}
